import { emeraldRequest } from '../../../common/api/emerald-request';
import { store } from '../../../common/redux/configure-store';
import { UserActions } from '../../../common/interfaces/dtos/UserActions';
import { LoginActions } from '../../../common/redux/reducers/login-reducer';
import XLRLogger from '../../../common/helpers/logger';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const getUserActions = async (): Promise<UserActions | undefined> => {
  const userName = store.getState().user.userName;
  const axiosConfig: AxiosRequestConfig = {
    url: `/user-management/users/${userName}/actions`,
    method: 'GET',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  if (userName) {
    await emeraldRequest<UserActions>(emeraldRequestParams)
      .then((userActions: UserActions) => {
        store.dispatch(LoginActions.setUserActions(userActions));
      })
      .catch(err => {
        XLRLogger.error({
          message: 'Get User Actions Error',
          source: 'get-user-actions.ts',
          data: err,
        });
      });
  }
  return undefined;
};
